import { Injectable } from '@angular/core';
import * as typeformEmbed from '@typeform/embed';
import { environment } from '../../../environments/environment';
import { getUserDetailsSelector } from '../user/user.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../models/state';

@Injectable()
export class TypeformService {
  private popupReference;
  private passedDetails = false;

  constructor(private store: Store<IState>) {}

  initTypeform() {
    this.store.select(getUserDetailsSelector).subscribe(details => {
      if (Object.keys(details).length && !this.passedDetails) {
        const { username, domain, companyName, name, surname } = details;

        this.popupReference = typeformEmbed.makePopup(
          `${
            environment.TYPEFORM_URL
          }?email=${username}&first_name=${name}&last_name=${surname}&organization=${companyName}&cc_domain=${domain}`,
          {
            mode: 'standard',
            hideHeaders: true,
            hideFooters: true
          }
        );
      }
    });
  }

  showSurvey() {
    if (this.popupReference) {
      this.popupReference.open();
    } else {
      throw new Error('Typeform not initialized');
    }
  }
}
